import { FastField, Field } from 'formik';
import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxControl } from './checkbox';
import { SelectControl } from './select';
import { InputControl } from './input';
import { ImageUploadControl } from './image-upload';
import { TimePickerControl } from './time-picker';
import { DateControl } from './date';
import { CheckboxGroupControl } from './checkbox-group';
import { RadioGroupControl } from './radio-group';
import { DateRangePickerControl } from './date-range-picker';
import { TimeRangePickerControl } from './time-range-picker';
import { InputNumberControl } from './input-number';
import { Flex } from 'rebass';
import { SliderControl } from './slider';
import { EditorControl } from './editor';
import { PhoneNumberControl } from './phone-number';
import { TransferControl } from './transfer';
import { TreeTransferControl } from './tree-transfer';

export const ControlTypes = {
  Checkbox: 'checkbox',
  CheckboxGroup: 'checkboxGroup',
  RadioGroup: 'radioGroup',
  Input: 'input',
  Select: 'select',
  ImageUpload: 'imageUpload',
  Date: 'date',
  TimePicker: 'timePicker',
  DateRangePicker: 'dateRangePicker',
  TimeRangePicker: 'timeRangePicker',
  InputNumber: 'inputNumber',
  Slider: 'slider',
  Editor: 'editor',
  PhoneNumber: 'phoneNumber',
  Transfer: 'transfer',
  TreeTransfer: 'treeTransfer',
};

const controls = {
  [ControlTypes.Checkbox]: CheckboxControl,
  [ControlTypes.CheckboxGroup]: CheckboxGroupControl,
  [ControlTypes.RadioGroup]: RadioGroupControl,
  [ControlTypes.Input]: InputControl,
  [ControlTypes.Select]: SelectControl,
  [ControlTypes.ImageUpload]: ImageUploadControl,
  [ControlTypes.Date]: DateControl,
  [ControlTypes.TimePicker]: TimePickerControl,
  [ControlTypes.DateRangePicker]: DateRangePickerControl,
  [ControlTypes.TimeRangePicker]: TimeRangePickerControl,
  [ControlTypes.InputNumber]: InputNumberControl,
  [ControlTypes.Slider]: SliderControl,
  [ControlTypes.Editor]: EditorControl,
  [ControlTypes.PhoneNumber]: PhoneNumberControl,
  [ControlTypes.Transfer]: TransferControl,
  [ControlTypes.TreeTransfer]: TreeTransferControl,
};

export function Control({ type = 'input', dependant = false, name, ...props }) {
  const Element = dependant ? Field : FastField;

  return (
    <Element name={name}>
      {({ field, meta }) => {
        return (
          <Flex className={meta.error && meta.touched && 'ant-form-item-has-error'} flexDirection="column">
            {React.createElement(controls[type], {
              ...field,
              ...props,
            })}
          </Flex>
        );
      }}
    </Element>
  );
}

Control.propTypes = {
  name: PropTypes.string,
  type: PropTypes.oneOf(Object.values(ControlTypes)),
  dependant: PropTypes.bool,
  width: PropTypes.any,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  settings: PropTypes.object,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  children: PropTypes.node,
};
